import type { DataDemandSource } from "@/lib/view-data-needs";

export const DATA_DEMAND_ENDPOINTS = {
  productsLite: ["/api/products/lite"],
  productsFull: ["/api/products"],
  orders: ["/api/orders"],
  attrs: ["/api/attributes"],
  prices: ["/api/prices"],
  ads: ["/api/performance", "/api/performance/by-product-periods"],
  clusters: ["/api/clusters"],
  inventory: ["/api/inventory"],
  costs: ["/api/cost-prices?light=1"],
  suppliers: ["/api/suppliers"],
  topQueries: ["/api/top-queries"],
  productGroups: ["/api/product-group-labels"],
  clusterStockHistory: ["/api/cluster-stock-history"],
  clusterOrderFlows: ["/api/cluster-order-flows?days=30"],
  contentRating: ["/api/content-rating"],
  turnoverHistory: ["/api/turnover-history"],
  batches: ["/api/batches"],
  supplies: ["/api/supplies"],
  finances: ["/api/finances"],
  promos: ["/api/promotions"],
  // Связанные значения /api/wb-linked грузит сам движок только при наличии
  // WB-колонки; общий контекст хранит лишь список доступных регионов.
  wb: ["/api/wb-regions"],
  actionDiary: ["/api/action-diary?days=14"],
  // Ряды календарей «по неделям» (lib/week-calendars).
  stockDays: ["/api/day-calendars?metric=stock"],
  priceDays: ["/api/day-calendars?metric=price"],
  adsDays: ["/api/day-calendars?metric=ads"],
  deliveryDays: ["/api/delivery-days"],
  productMoney: ["/api/product-money"],
} as const satisfies Record<DataDemandSource, readonly string[]>;

/**
 * Что из первой волны стоит греть заранее: лёгкий каталог не нужен, когда с
 * порога нужен полный — ProductsProvider (app/context/DataContext.tsx) его
 * тогда пропускает, и прогрев лёгкого уходил бы впустую (1,7–2 МБ и проход
 * сервера на магазине из 1581 товара).
 */
export function warmupDataDemandSources(sources: readonly DataDemandSource[]): DataDemandSource[] {
  return sources.includes("productsFull") ? sources.filter(source => source !== "productsLite") : [...sources];
}

export function getDataDemandEndpoints(source: DataDemandSource): readonly string[] {
  return DATA_DEMAND_ENDPOINTS[source];
}
